'use client';
import Link from 'next/link';
import DynamicImage from '@/components/DynamicImage';
import { motion } from 'framer-motion';
import { useEffect, useState } from 'react';
// import { AnimatedButton } from './common/AnimatedButton';
// import RegisDialog from './regisDialog';

const Headermobile = () => {
  return (
    <section className="relative w-full h-full">
      <DynamicImage
        src="https://osscdn.weiyouzhihui.com/editorVideo/1736411796361/image%201943%402x.png"
        className="w-full h-347"
      ></DynamicImage>
      <DynamicImage
        src="https://osscdn.weiyouzhihui.com/editorVideo/1736411865301/Frame%20427319442%402x.png"
        className="w-[98px] h-[26px] absolute left-[20px] top-[10px]"
      ></DynamicImage>
    </section>
  );
};

export default Headermobile;
